<template src="./html/Subnavbar.html"></template>

<script>

export default {
	props: ['user', 'isAuth'],
}
</script>


// WEBPACK FOOTER //
// src/components/partials/views/Subnavbar.vue